export default {"src":"/_next/static/media/trial-active.2af7321f.svg","height":260,"width":260,"blurWidth":0,"blurHeight":0};